

import React, { useEffect } from 'react';

import { Singleton } from '../../js/Singleton';
import { hangUp } from '../../Images/CallSpaceHeaderSVG';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import busy_sound from '../../audios/busy-sound.mp3';
import other_sound from '../../audios/other-congestion-not_service.mp3';
import fax_machine_sound from '../../audios/Fax-machine-sound.mp3';

const language = new Singleton();

function AlertManualCallWindow (props) {
	const {icon = true, buttonClose = true} = props;
	const audioBusy = new Audio(busy_sound);
	const audioOther = new Audio(other_sound);
	const audioFaxMachine = new Audio(fax_machine_sound);
	
	
	useEffect(() => {
		if (props.alertCode) {
			playAudio(3000);
		}
	}, [props.alertCode]);

	const getMessageAlert = (complete = false) => {
		let message = props.alertCode === 'CUSTOM' ? props.message : language.getText('alert-' + props.alertCode);
		if (!complete && message && message.length > 100) {
			message = message.slice(0, 90) + '...';
		}
		return message;
	};
	const onClickHandler = () => {
		props.closeAlert(false);

		playAudio(0);
	};
	const playAudio = time => {
		if(!props.playStopAudio)
			return;
		switch (props.alertCode) {
			case '1500':
				//Ocupado -> Linea ocupada
				props.playStopAudio(audioBusy, time);
				break;
			case '1507':
			//sin servicio 1507 -> Número incorrecto/fuera de servicio
			case '1505':
			//Congestion 1505 -> Error de central telefónica
			case '1506':
				//Otro 1506 -> Error de central telefónica
				props.playStopAudio(audioOther, time);
				break;
			case '1502':
				//Fax/Modem 1502 -> Máquina de fax detectada
				props.playStopAudio(audioFaxMachine, time);
				break;
			default:
				break;
		}
	};


	return (
		<div className={`alertWindowContainer ${props.className || ''}`}>
			<div className='alertWindow'>
				{ props.phoneNumber &&
					<p className='alertNumber'>{props.phoneNumber}</p>
				}
				<div className='alertInfoContainer'>
					{ icon && <div className='iconAlert'>{hangUp}</div> }
					<OverlayTrigger
						key='tlt-alertManualCallWindow'
						placement='right'
						overlay={
							<Tooltip className='workbar-tooltip show' id='tooltipId-tlt-alertManualCallWindow'>
								{getMessageAlert(true)}
							</Tooltip>
						}>
						<p className='alertText'>{getMessageAlert()}</p>
					</OverlayTrigger>
				</div>
				{ buttonClose &&
					<div className='closeAlert' onClick={onClickHandler}>
						{language.getText('CallControlGUIAssistedCallTransferaccept')}
					</div>
				}
			</div>
		</div>
	);
	
}

export default AlertManualCallWindow;



// WEBPACK FOOTER //
// ./src/components/Alerts/AlertManualCallWindow.jsx